import React, { useEffect, useState } from "react";
import { Button } from "reactstrap";

const FileInfoBlock = ({documentDetail, refreshFiles}) => {
	const [documentInfo, setDocumentInfo] = useState(documentDetail)

	useEffect(()=>{
		setDocumentInfo(documentDetail)
	
	}, [documentDetail])
	return (
		<>
			<div className="file-info-block d-flex overflow-auto flex-shrink-0">
				<div className="info-col column-1">
					<p>
						<label>Borrower Name:</label> N/A
					</p>
					<p>
						<label>Loan #:  </label>{documentInfo?.loan_number}
					</p>
					<p>
						<label>Work Group:</label>{documentInfo?.location?.name}
					</p>
				</div>
				<div className="info-col column-2">
					<p>
						<label># of Borrowers:</label>N/A
					</p>
				</div>
				<div className="info-col column-3">
					<p>
						<label>Loan Officer: </label>N/A
						<span className="icon">
							{/* <img className="img-fluid" src={require('../../../../assets/img/mail-icon.svg')} alt="mail-icon" data-tip="E-mail"/>
							&nbsp; &nbsp;
							<img className="img-fluid" width={"18"} src={require('../../../../assets/img/copy.png')} alt="copy-icon" data-tip="Copy"/> */}
						</span>
					</p>
					<p>
						<label>ALO:</label>N/A
					</p>
					<p>
						<label>Processor:</label>N/A
					</p>
				</div>
				<div className="info-col column-4 d-flex align-items-start">
					<div className="inner">
						<p>
							<label>Underwriter  </label>N/A
							<span className="icon">
								{/* <img className="img-fluid" src={require('../../../../assets/img/mail-icon.svg')} alt="mail-icon" data-tip="E-mail"/>
								&nbsp; &nbsp;
								<img className="img-fluid" width={"18"} src={require('../../../../assets/img/copy.png')} alt="copy-icon" data-tip="Copy"/> */}
							</span>
						</p>
						<p>
							<label>Closer: </label>N/A<span className="icon">
								{/* <img className="img-fluid" src={require('../../../../assets/img/mail-icon.svg')} alt="mail-icon" data-tip="E-mail"/>&nbsp; &nbsp;
								<img className="img-fluid" width={"18"} src={require('../../../../assets/img/copy.png')} alt="copy-icon" data-tip="Copy"/> */}
							</span>
						</p>
						<p>
							<label>Post-Closer: </label>N/A<span className="icon">
								{/* <img className="img-fluid" src={require('../../../../assets/img/mail-icon.svg')} alt="mail-icon" data-tip="E-mail"/>
								&nbsp; &nbsp;
								<img className="img-fluid" width={"18"} src={require('../../../../assets/img/copy.png')} alt="copy-icon" data-tip="Copy"/> */}
							</span>
						</p>
					</div>
					<Button color="link" className="refresh-btn p-0 d-inline-flex align-items-center justify-content-center" onClick={refreshFiles} data-tip ="Reload Document">
						<img className="img-fluid" src={require('../../../../assets/img/refresh-icon.png')} alt="refresh-icon" />

					</Button>
				</div>
			</div>
		</>
	)
};
export default FileInfoBlock;